<template>
  <div class="card menu-item" @click="gotoMeal">
    <div v-if="badgeText" class="menu-item-badge" :class="badgeClass">
      {{ badgeText }}
    </div>

    <div class="menu-item-image-container">
      <img :src="mediaSrc(item.dish.photo)" class="menu-item-image" />
      <div v-if="item.dish.rate !== 0" class="menu-item-rate">
        <font-awesome-icon :icon="['fas', 'star']" class="rate-star-icon" />
        <span class="rate-number">{{ item.dish.rate }}</span>
      </div>
    </div>

    <div class="menu-item-meal">{{ item.dish_type_display }}</div>
    <div class="menu-item-name">{{ item.dish.name }}</div>

    <div class="menu-item-bottom-bar">
      <button class="button circle" @click.stop="showReplaceModal = true">
        <font-awesome-icon class="icon" :icon="['fas', 'arrows-rotate']" />
      </button>

      <button class="button circle" @click.stop="toggleLikeRecipe">
        <font-awesome-icon v-if="item.dish.liked" class="icon" :icon="['fas', 'heart']" />
        <font-awesome-icon v-else class="icon" :icon="['far', 'heart']" />
      </button>

      <SocialSharingModal :dish="item.dish" />
    </div>

    <ReplaceDishModal
      v-if="showReplaceModal"
      @click.stop
      :item="item"
      :date="date"
      @close="showReplaceModal = false"
      @update="update"
    />
  </div>
</template>

<script>
import { api } from "@/api";
import SocialSharingModal from "@/components/SocialSharingModal.vue";
import ReplaceDishModal from "@/components/ReplaceDishModal.vue";

export default {
  name: "MenuItemCard",
  components: {
    SocialSharingModal,
    ReplaceDishModal,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    mealBadgeType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showReplaceModal: false,
    };
  },
  computed: {
    badgeText() {
      if (this.mealBadgeType === "parent_leftovers") {
        if (["lunch_starter", "lunch_main"].includes(this.item.dish_type)) {
          return "Quantités déjà ajustées pour deux repas";
        }

        if (["diner_starter", "diner_main"].includes(this.item.dish_type)) {
          return "Quantités déjà ajustées pour deux repas";
        }

        return "Quantités déjà ajustées pour deux repas";
      }

      if (this.mealBadgeType === "leftovers") {
        return "Repas à base de restes";
      }

      if (this.item.meal_origin_type === "leftovers") {
        return "Repas à base de restes";
      }

      return null;
    },
    badgeClass() {
      if (this.mealBadgeType === "parent_leftovers") {
        return "menu-item-badge-parent";
      }

      if (this.mealBadgeType === "leftovers" || this.item.meal_origin_type === "leftovers") {
        return "menu-item-badge-leftovers";
      }

      return "";
    },
  },
  methods: {
    gotoMeal() {
      this.$router.push({
        name: "my-meal",
        params: { date: this.date, meal: this.item.meal },
      });
    },
    toggleLikeRecipe() {
      api.post(`/recipes/${this.item.dish.id}/toggle_like/`)
        .then((response) => {
          this.$emit("update", {
            ...this.item,
            dish: {
              ...this.item.dish,
              liked: !this.item.dish.liked,
              nb_likes: response.data.nb_likes,
            },
          });
        });
    },
    update(item) {
      this.$emit("update", item);
    },
    mediaSrc(uri) {
      return `${process.env.VUE_APP_BASE_URL}${uri}`;
    },
  },
};
</script>

<style scoped>
.day-selector {
  display: flex;
  justify-content: center;
  gap: 20px;
  align-items: center;
}

.day-selector-arrow {
  cursor: pointer;
  background: #436f0e;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.day-selector-previous-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
}

.day-selector-current-day {
  font-size: 30px;
  font-family: "Amanise";
  font-weight: 500;
  color: #436f0e;
}

.day-selector-next-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
}

.menu-container {
  display: flex;
  justify-content: center;
}

.menu-item {
  background: white;
  padding: 20px;
  margin: 10px;
  width: 200px;
  min-width: 150px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.menu-item:hover {
  box-shadow: 0px 0px 10px #436f0e;
}

.menu-item-badge {
  margin: -20px -20px 12px -20px;
  padding: 10px 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: white;
}

.menu-item-badge-parent {
  background: #4a7d1a;
  position: absolute;
  z-index: 10;
  width: 100%;
}

.menu-item-badge-leftovers {
  background: #4a7d1a;
  position: absolute;
  z-index: 10;
  width: 100%;
}

.menu-item-image-container {
  width: 100%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 10px;
}

.menu-item-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

.menu-item-rate {
  position: absolute;
  top: -10px;
  right: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.rate-star-icon {
  color: gold;
  font-size: 30px;
  position: relative;
}

.rate-number {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: black;
}

.menu-item-meal {
  font-size: 20px;
  font-weight: 800;
  color: #436f0e;
}

.menu-item-name {
  font-size: 15px;
}

.menu-item-bottom-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: auto;
  padding-top: 10px;
  gap: 10px;
}

.scale-selector {
  display: flex;
  justify-content: center;
}

.scale-selector-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
  cursor: pointer;
  border: 1px solid #436f0e;
  border-right: none;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px;
  background: white;
}

.scale-selector-day.active {
  background: #436f0e;
  color: white;
  border: none;
}

.scale-selector-day:hover {
  background: #85a063;
  color: white;
  border: none;
}

.scale-selector-week {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
  cursor: pointer;
  border: 1px solid #436f0e;
  border-left: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  background: white;
}

.scale-selector-week.active {
  background: #436f0e;
  color: white;
  border: none;
}

.scale-selector-week:hover {
  background: #85a063;
  color: white;
  border: none;
}
</style>
